module.exports = __webpack_public_path__ + "media/images/property-tour-placeholder-459ac8cf.png";